import './AboutPage.css';
import { aboutSections } from './AboutRes';

export default function AboutPage() {
  return (
    <div className="about-scroll-container">
      {aboutSections.map((s, i) => {
        const isPortrait = s.type === "portrait";
        const Tag = s.heading;
        return (
          <div key={i} className={`about-root ${isPortrait ? 'portrait' : 'landscape'}`}>

            <div className="img-panel">
              <img src={s.img} alt={s.alt} loading={i === 0 ? "eager" : "lazy"} />
            </div>

            {!isPortrait && <div className="blur-bg" />}

            <div className="content-panel">
              <div className="content-inner">
                <div className="ribbon">
                  <div className="ribbon-sq sq-red" />
                  <div className="ribbon-sq sq-blue" />
                  <div className="ribbon-sq sq-yellow" />
                  <div className="ribbon-sq sq-green" />
                </div>
                <div className="accent-line" />
                <Tag className="mission-text">{s.mission}</Tag>

                {s.source && <p className="source-text">~ {s.source}</p>}

                <p className="read-text">{s.read}</p>
                {s.readMoreLink && (
                  <a className="read-more-link" href={s.readMoreLink} target="_blank" rel="noopener noreferrer">
                    Read the study ↗
                  </a>
                )}

              </div>
            </div>

          </div>
        );
      })}
    </div>
  );
}